import script from "./CarouselLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./CarouselLayout.vue?vue&type=script&setup=true&lang=ts"

import "./CarouselLayout.vue?vue&type=style&index=0&id=0d8fb3f4&lang=css"

const __exports__ = script;

export default __exports__